// All site copy lives here. Two languages: ro (default) and en.
// Every component reads from this dictionary via LanguageContext.

export const translations = {
  ro: {
    nav: {
      home: "Acasă",
      portfolio: "Portofoliu",
      about: "Despre Noi",
      contact: "Contact",
      menuOpen: "Deschide meniul",
      menuClose: "Închide meniul",
      language: "Limbă",
    },
    footer: {
      tagline:
        "Construim site-uri profesionale pentru afaceri locale din România, rapide, moderne și complet optimizate pentru mobil. De la restaurante și clinici, până la firme de construcții, transformăm ideile clienților noștri în prezențe online care aduc rezultate reale.",
      sectionLinks: "Navigare",
      sectionContact: "Contact",
      contactPhoneLabel: "Telefon",
      contactEmailLabel: "Email",
      contactLocationLabel: "Locație",
      location: "Constanța, România",
      rights: "Toate drepturile rezervate.",
    },
    home: {
      heroLabel: "AGENȚIE WEB · CONSTANȚA",
      heroTitle: "Site-uri care aduc clienți noi.",
      heroSubtitle:
        "Construim prezențe online profesionale pentru afaceri locale – rapid, modern și complet optimizat.",
      ctaPrimary: "Hai să vorbim",
      ctaSecondary: "Vezi portofoliul",
      stats: [
        { value: "10+", label: "Proiecte livrate" },
        { value: "7–10", label: "Zile până la lansare" },
        { value: "100%", label: "Clienți satisfăcuți" },
        { value: "12h", label: "Timp de răspuns" },
      ],
      aboutLabel: "DESPRE NOI",
      aboutTitle: "O agenție mică. Rezultate mari.",
      aboutP1:
        "Ancor Digital este o agenție web din Constanța, specializată în site-uri profesionale pentru afaceri mici și mijlocii.",
      aboutP2:
        "Lucrăm direct cu antreprenorii – fără termeni tehnici, fără bătăi de cap. Doar rezultate vizibile, online.",
      aboutLink: "Cunoaște echipa",
      featureRows: [
        { emoji: "⚡", label: "Livrare în 7–10 zile" },
        { emoji: "📱", label: "Mobile-first" },
        { emoji: "🎨", label: "Design Modern" },
      ],
      processTitle: "Cum Funcționează",
      processSubtitle: "De la idee la site live – în 3 pași simpli.",
      processSteps: [
        {
          emoji: "💬",
          title: "Pas 1 – Discutăm",
          desc: "Ne contactezi, îți înțelegem afacerea și ce vrei să transmită site-ul tău. Fără termeni tehnici, fără complicații. O discuție simplă, pe WhatsApp sau telefon.",
        },
        {
          emoji: "🛠️",
          title: "Pas 2 – Construim",
          desc: "În 7–10 zile lucrătoare, site-ul tău profesional este gata. Îți trimitem un link de previzualizare înainte de lansare – îl poți vedea și aproba înainte să fie public.",
        },
        {
          emoji: "🚀",
          title: "Pas 3 – Lansăm",
          desc: "Aprobăm împreună, conectăm domeniul tău și site-ul este live. Gata să atragă noi clienți pentru afacerea ta.",
        },
      ],
      processInfo:
        "⏱️ Timp total estimat: 7–10 zile lucrătoare de la prima discuție până la lansare.",
      whyTitle: "De ce Ancor Digital",
      whyItems: [
        {
          emoji: "⚡",
          title: "Livrare rapidă",
          desc: "Site-ul tău este gata în 7–10 zile. Nu în luni de zile.",
        },
        {
          emoji: "🎨",
          title: "Design modern",
          desc: "Folosim tehnologiile și tendințele actuale. Site-ul tău va arăta mai bine decât al concurenței.",
        },
        {
          emoji: "📱",
          title: "Mobile-first",
          desc: "Peste 70% din vizitatori vin de pe telefon. Toate site-urile noastre arată perfect pe orice ecran.",
        },
        {
          emoji: "🎯",
          title: "Soluții dedicate",
          desc: "Ne concentrăm exclusiv pe crearea de site-uri web profesionale care aduc rezultate reale.",
        },
      ],
      finalCtaTitle: "Pregătit să atragi mai mulți clienți online?",
      finalCtaSubtitle:
        "Contactează-ne azi, îți răspundem în mai puțin de 12 ore.",
      finalCtaButton: "Contactează-ne",
    },
    portfolio: {
      headerTitle: "Portofoliu",
      headerSubtitle:
        "Proiecte realizate – fiecare construit de la zero, adaptat specificului afacerii",
      intro:
        "Fiecare proiect din portofoliul nostru a fost construit de la zero, adaptat specificului fiecărei afaceri. Mai jos găsiți exemple reprezentative din colaborările noastre recente.",
      viewProject: "Vezi proiectul",
      items: [
        {
          emoji: "🍷",
          name: "Restaurant Elegant",
          category: "Restaurante & HoReCa",
          desc: "Site de prezentare pentru restaurant fine dining.",
          domain: "restaurant.ancordigital.ro",
          gradient: "linear-gradient(135deg, #1a0a0a, #6B0F1A)",
        },
        {
          emoji: "💄",
          name: "Salon de Beauty",
          category: "Beauty & Wellness",
          desc: "Site modern pentru salon de make-up și îngrijire.",
          domain: "salon.ancordigital.ro",
          gradient: "linear-gradient(135deg, #2d0036, #c06090)",
        },
        {
          emoji: "🦷",
          name: "Clinică Dentară",
          category: "Sănătate & Medical",
          desc: "Site profesional pentru clinică stomatologică.",
          domain: "clinica.ancordigital.ro",
          gradient: "linear-gradient(135deg, #03045E, #0ABFBC)",
        },
        {
          emoji: "🏗️",
          name: "Firmă de Construcții",
          category: "Construcții & Imobiliare",
          desc: "Site corporatist pentru firmă de construcții rezidențiale.",
          domain: "constructii.ancordigital.ro",
          gradient: "linear-gradient(135deg, #1B2A4A, #2D3748)",
        },
      ],
      ctaText:
        "📩 Vrei un site similar? Contactează-ne și hai să transformăm ideea ta în realitate în 12h.",
      ctaButton: "Contactează-ne",
    },
    about: {
      headerTitle: "Despre Noi",
      headerSubtitle:
        "Doi oameni. Un singur obiectiv: site-ul tău să funcționeze pentru afacerea ta.",
      sectionLabel: "DESPRE ANCOR DIGITAL",
      sectionTitle: "O agenție mică. Atenție mare la detalii.",
      paragraphs: [
        "Ancor Digital este o agenție web din Constanța, specializată în site-uri profesionale pentru afaceri mici și mijlocii din România.",
        "Lucrăm cu restaurante, clinici, saloane, firme de construcții și alți antreprenori locali care vor să fie găsiți online – fără bătăi de cap și cu o abordare directă.",
        "Folosim cele mai noi tehnologii disponibile pentru a livra site-uri rapide, mobile-friendly și cu un design care inspiră încredere din prima secundă.",
        "Nu avem zeci de angajați. Avem în schimb atenție la detalii, timp de răspuns rapid și un singur obiectiv: succesul prezenței tale online.",
      ],
      team: [
        {
          initials: "ATB",
          name: "Alexandru Thury Burileanu",
          role: "WEB DESIGN & DEVELOPMENT",
          bio: "Responsabil de design, dezvoltare și livrarea fiecărui proiect. Pasionat de tehnologie și de soluții digitale care fac diferența pentru afacerile locale.",
          badges: ["React", "UI/UX Design", "Frontend Dev", "Client Relations"],
        },
        {
          initials: "DLF",
          name: "Deacu Luca Florian",
          role: "CLIENT RELATIONS & STRATEGIE",
          bio: "Responsabil de relația cu clienții, înțelegerea nevoilor lor și traducerea acestora în cerințe clare pentru proiect. Primul punct de contact pentru orice colaborare.",
          badges: [
            "Client Relations",
            "Strategie digitală",
            "Copywriting",
            "Project Management",
          ],
        },
      ],
      valuesTitle: "Cum lucrăm",
      values: [
        {
          emoji: "🎯",
          title: "Personalizat",
          desc: "Fiecare site este gândit specific pentru afacerea ta, nu copiat dintr-un template generic.",
        },
        {
          emoji: "🔍",
          title: "Claritate",
          desc: "Știi mereu în ce stadiu se află proiectul tău și când va fi lansat. Fără surprize.",
        },
        {
          emoji: "📞",
          title: "Accesibil",
          desc: "Suntem la un mesaj sau un apel distanță pe toată durata proiectului și după lansare.",
        },
      ],
    },
    contact: {
      headerTitle: "Contact",
      headerSubtitle: "Hai să vorbim despre proiectul tău",
      intro:
        "Spune-ne câteva cuvinte despre afacerea ta și ce ai nevoie. Îți răspundem în mai puțin de 12 ore.",
      phoneLabel: "Sună-ne direct",
      emailLabel: "Scrie-ne pe email",
      hoursLabel: "Program",
      hoursDay: "Luni – Vineri",
      hoursTime: "09:00 – 20:00",
      locationLabel: "Locație",
      location: "Constanța, România",
    },
  },
  en: {
    nav: {
      home: "Home",
      portfolio: "Portfolio",
      about: "About Us",
      contact: "Contact",
      menuOpen: "Open menu",
      menuClose: "Close menu",
      language: "Language",
    },
    footer: {
      tagline:
        "We build professional websites for local businesses across Romania, fast, modern, and fully optimized for mobile. From restaurants and clinics to construction firms, we turn our clients' ideas into online presences that deliver real results.",
      sectionLinks: "Navigate",
      sectionContact: "Contact",
      contactPhoneLabel: "Phone",
      contactEmailLabel: "Email",
      contactLocationLabel: "Location",
      location: "Constanța, Romania",
      rights: "All rights reserved.",
    },
    home: {
      heroLabel: "WEB AGENCY · CONSTANȚA",
      heroTitle: "Websites that bring in new clients.",
      heroSubtitle:
        "We build professional online presences for local businesses – fast, modern, and fully optimized.",
      ctaPrimary: "Let's talk",
      ctaSecondary: "View portfolio",
      stats: [
        { value: "10+", label: "Projects delivered" },
        { value: "7–10", label: "Days to launch" },
        { value: "100%", label: "Happy clients" },
        { value: "12h", label: "Response time" },
      ],
      aboutLabel: "ABOUT US",
      aboutTitle: "A small agency. Big results.",
      aboutP1:
        "Ancor Digital is a web agency from Constanța, specialized in professional websites for small and medium businesses.",
      aboutP2:
        "We work directly with entrepreneurs – no jargon, no hassle. Just visible online results.",
      aboutLink: "Meet the team",
      featureRows: [
        { emoji: "⚡", label: "Delivery in 7–10 days" },
        { emoji: "📱", label: "Mobile-first" },
        { emoji: "🎨", label: "Modern Design" },
      ],
      processTitle: "How It Works",
      processSubtitle: "From idea to live site – in 3 simple steps.",
      processSteps: [
        {
          emoji: "💬",
          title: "Step 1 – We Talk",
          desc: "You reach out, we understand your business and what your website should communicate. No technical terms, no complications. A simple chat on WhatsApp or phone.",
        },
        {
          emoji: "🛠️",
          title: "Step 2 – We Build",
          desc: "In 7–10 working days, your professional website is ready. We send you a preview link before launch – you can see and approve it before going public.",
        },
        {
          emoji: "🚀",
          title: "Step 3 – We Launch",
          desc: "We approve together, connect your domain and the site goes live. Ready to attract new clients for your business.",
        },
      ],
      processInfo:
        "⏱️ Estimated total time: 7–10 working days from first conversation to launch.",
      whyTitle: "Why Ancor Digital",
      whyItems: [
        {
          emoji: "⚡",
          title: "Fast delivery",
          desc: "Your site is ready in 7–10 days. Not months.",
        },
        {
          emoji: "🎨",
          title: "Modern design",
          desc: "We use current technologies and trends. Your site will look better than the competition's.",
        },
        {
          emoji: "📱",
          title: "Mobile-first",
          desc: "Over 70% of visitors come from phones. All our sites look perfect on any screen.",
        },
        {
          emoji: "🎯",
          title: "Focused solutions",
          desc: "We exclusively focus on building professional websites that deliver real results.",
        },
      ],
      finalCtaTitle: "Ready to attract more clients online?",
      finalCtaSubtitle:
        "Reach out today, we reply in less than 12 hours.",
      finalCtaButton: "Contact us",
    },
    portfolio: {
      headerTitle: "Portfolio",
      headerSubtitle:
        "Projects delivered – each built from scratch, tailored to the business",
      intro:
        "Every project in our portfolio was built from scratch, tailored to each business's specifics. Below you'll find representative examples from our recent collaborations.",
      viewProject: "View project",
      items: [
        {
          emoji: "🍷",
          name: "Elegant Restaurant",
          category: "Restaurants & HoReCa",
          desc: "Presentation site for a fine dining restaurant.",
          domain: "restaurant.ancordigital.ro",
          gradient: "linear-gradient(135deg, #1a0a0a, #6B0F1A)",
        },
        {
          emoji: "💄",
          name: "Beauty Salon",
          category: "Beauty & Wellness",
          desc: "Modern site for a make-up and care salon.",
          domain: "salon.ancordigital.ro",
          gradient: "linear-gradient(135deg, #2d0036, #c06090)",
        },
        {
          emoji: "🦷",
          name: "Dental Clinic",
          category: "Health & Medical",
          desc: "Professional site for a dental clinic.",
          domain: "clinica.ancordigital.ro",
          gradient: "linear-gradient(135deg, #03045E, #0ABFBC)",
        },
        {
          emoji: "🏗️",
          name: "Construction Company",
          category: "Construction & Real Estate",
          desc: "Corporate site for a residential construction firm.",
          domain: "constructii.ancordigital.ro",
          gradient: "linear-gradient(135deg, #1B2A4A, #2D3748)",
        },
      ],
      ctaText:
        "📩 Want a similar site? Reach out and let's turn your idea into reality in 12h.",
      ctaButton: "Contact us",
    },
    about: {
      headerTitle: "About Us",
      headerSubtitle:
        "Two people. One goal: making your website work for your business.",
      sectionLabel: "ABOUT ANCOR DIGITAL",
      sectionTitle: "A small agency. Big attention to detail.",
      paragraphs: [
        "Ancor Digital is a web agency from Constanța, specialized in professional websites for small and medium businesses across Romania.",
        "We work with restaurants, clinics, salons, construction firms and other local entrepreneurs who want to be found online – without hassle and with a direct approach.",
        "We use the latest available technologies to deliver fast, mobile-friendly websites with a design that inspires trust from the first second.",
        "We don't have dozens of employees. Instead, we have attention to detail, fast response time, and a single goal: the success of your online presence.",
      ],
      team: [
        {
          initials: "ATB",
          name: "Alexandru Thury Burileanu",
          role: "WEB DESIGN & DEVELOPMENT",
          bio: "Responsible for design, development and delivery of every project. Passionate about technology and digital solutions that make a difference for local businesses.",
          badges: ["React", "UI/UX Design", "Frontend Dev", "Client Relations"],
        },
        {
          initials: "DLF",
          name: "Deacu Luca Florian",
          role: "CLIENT RELATIONS & STRATEGY",
          bio: "Responsible for client relations, understanding their needs and translating them into clear project requirements. First point of contact for any collaboration.",
          badges: [
            "Client Relations",
            "Digital Strategy",
            "Copywriting",
            "Project Management",
          ],
        },
      ],
      valuesTitle: "How we work",
      values: [
        {
          emoji: "🎯",
          title: "Personalized",
          desc: "Every site is designed specifically for your business, not copied from a generic template.",
        },
        {
          emoji: "🔍",
          title: "Clarity",
          desc: "You always know what stage your project is at and when it will launch. No surprises.",
        },
        {
          emoji: "📞",
          title: "Accessible",
          desc: "We're a message or call away throughout the project and after launch.",
        },
      ],
    },
    contact: {
      headerTitle: "Contact",
      headerSubtitle: "Let's talk about your project",
      intro:
        "Tell us a few words about your business and what you need. We reply in less than 12 hours.",
      phoneLabel: "Call us directly",
      emailLabel: "Email us",
      hoursLabel: "Hours",
      hoursDay: "Monday – Friday",
      hoursTime: "09:00 – 20:00",
      locationLabel: "Location",
      location: "Constanța, Romania",
    },
  },
};

export const PHONE_DISPLAY = "+40 733 494 102";
export const PHONE_TEL = "+40733494102";
export const EMAIL = "contact@ancordigital.ro";